import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Polyfill for Array.prototype.at (required for web-vitals on older browsers)
// Fixes: TypeError: this.o.at is not a function
if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function(index) {
    const len = this.length;
    const relativeIndex = index < 0 ? len + index : index;
    if (relativeIndex < 0 || relativeIndex >= len) return undefined;
    return this[relativeIndex];
  };
}

// Initialize Sentry for error tracking with safe web-vitals config
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV || "production",
  tracesSampleRate: 0.05,
  // Disable browser profiling integration that may use web-vitals features
  integrations: (integrations) => {
    return integrations.filter((integration) => {
      // Keep all integrations except problematic ones on old browsers
      return integration.name !== 'BrowserProfiling';
    });
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="min-h-screen bg-black flex items-center justify-center text-white">Une erreur est survenue. Veuillez rafraîchir la page.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
